// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1628219757447
      var cssReload = require("/Users/stelterd/Sites/Display/spr-display-builder/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  